import _jsx from "@babel/runtime/helpers/jsx";
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useFeatures } from '@atc/features';
import BatteryHealthBadge from './badges/BatteryHealthBadge';
import CertifiedBadge from './badges/CertifiedBadge';
import FuelTypeBadge from './badges/FuelTypeBadge';
import ProductBadge from './badges/ProductBadge';
import VHRBadge from './badges/VHRBadge';

/**
 *  Displays applicable info badges on listing cards:
 *  - Battery Health
 *  - Highlight alternative fuel type
 *  - Certified program
 *  - Vehicle History Report quick link
 *
 */
function InventoryListingBadges(_ref) {
  let {
    enableCertifiedBadges = true,
    enableCpoVhrBadges,
    enableVhrBadges = false,
    enableFuelTypeBadges = true,
    listing,
    onCertifiedTileClick,
    onProductTileClick,
    onVhrBadgeClick
  } = _ref;
  const {
    battery_health: [enableBatteryHealth]
  } = useFeatures(['battery_health']);
  const {
    certifiedTiles = [],
    electricComponentInfo: {
      batteryDegradationInfo
    } = {},
    fuelType,
    listingType = '',
    listingTypes = [],
    productTiles = [],
    specifications,
    vhrPreview = [],
    vdpBaseUrl = ''
  } = listing || {};
  const handleCertifiedTileClick = useCallback(event => onCertifiedTileClick(event, listing), [listing, onCertifiedTileClick]);
  const handleProductTileClick = useCallback(event => onProductTileClick(event, listing), [listing, onProductTileClick]);
  const handleVhrBadgeClick = useCallback(event => onVhrBadgeClick(event, listing), [listing, onVhrBadgeClick]);
  return /*#__PURE__*/_jsx("div", {
    className: "display-flex flex-wrap gap-2"
  }, void 0, enableCertifiedBadges && certifiedTiles.map(_ref2 => {
    let {
      label
    } = _ref2;
    return /*#__PURE__*/_jsx(CertifiedBadge, {
      label: label,
      listingType: listingType,
      listingTypes: listingTypes,
      onClick: handleCertifiedTileClick
    }, label);
  }), enableFuelTypeBadges && /*#__PURE__*/_jsx(FuelTypeBadge, {
    engineName: specifications?.engine?.value,
    fuelGroup: fuelType?.group,
    fuelName: fuelType
  }, "fuel-type"), enableBatteryHealth && /*#__PURE__*/React.createElement(BatteryHealthBadge, Object.assign({
    key: "battery-health"
  }, batteryDegradationInfo)), enableCpoVhrBadges && productTiles.map(badge => /*#__PURE__*/React.createElement(ProductBadge, Object.assign({}, badge, {
    key: badge.label,
    onClick: handleProductTileClick
  }))), enableVhrBadges && vhrPreview.map(code => /*#__PURE__*/_jsx(VHRBadge, {
    vdpBaseUrl: vdpBaseUrl,
    vhrCode: code,
    listingType: listingType,
    onClick: handleVhrBadgeClick
  }, code)));
}
export default InventoryListingBadges;